<template>
  <BlockWrapper class="block-achievment">
    <bim-text type=h5 bold class="block-achievment__title">Серьезные награды в рублях</bim-text>
    <bim-row class="justify-center" justify=center>
      <bim-col
        cols=12
        md=6
        xl=4
        v-for="achievment of achievments"
        :key="achievment.percent"
        class="achievment"
      >
        <div class="d-flex align-end">
          <bim-text type=accent bold class="achievment__percent">{{ achievment.percent }}</bim-text>
          <bim-text
            type=accent
            bold
            class="achievment__percent-info"
            :style="{ fontSize: achievment.titleSize || null }"
          >
            {{ achievment.title }}
          </bim-text>
        </div>
        <bim-text type=main v-html="achievment.desc" class="mt-10 mb-11"></bim-text>
        <bim-text type=main class="mb-9" bold>{{ achievment.money }}</bim-text>
        <div class="d-flex align-center">
          <img :src="achievment.img" :width="achievment.imgWidth" alt />
          <bim-text type=accent class="ml-9">{{ achievment.info }}</bim-text>
        </div>
      </bim-col>
    </bim-row>
  </BlockWrapper>
</template>

<script>
import bimRow from '@bimlib/components/bimRow'
import bimCol from '@bimlib/components/bimCol'
import bimContainer from '@bimlib/components/bimContainer'

export default {
  name: "block",
  components: {
    bimCol,
    bimRow,
    bimContainer,
  },
  inject: ['getImgPath'],
  data() {
    return {
      achievments: [
        {
          percent: "10%",
          title: "от первой сделки клиента",
          titleSize: '17px',
          desc: "Что эквивалентно <b>15 000 руб.</b> при среднем чеке сделки в 150 000 рублей. Вы можете заработать даже больше!",
          money: "15 000 рублей это:",
          img: this.getImgPath('phonebitmap@2x.png'),
          imgWidth: '54px',
          info: "Смартфон SAMSUNG GALAXY A11",
        },
        {
          percent: "10 000",
          title: "рублей",
          desc: "За привлечение клиента на тариф <b><span class=primary>Единый</span></b>.",
          money: "10 000 рублей это:",
          img: this.getImgPath('bicyclebitmap@2x.png'),
          imgWidth: '122px',
          info: "Городской велосипед STELS Pilot",
        },
        {
          percent: "25 000",
          title: "рублей",
          desc: "За привлечение клиента на тариф <b><span class=luxury>Максимум</span></b>.",
          money: "25 000 рублей это:",
          img: this.getImgPath('img-special-landing-cash-prod-3.png'),
          imgWidth: '120px',
          info: "Ноутбук ASUS VivoBook 15",
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.block-achievment {
  padding: 80px 0;

  .block-achievment__title {
    margin-bottom: 80px;
    text-align: center;
  }

  .achievment {

    ::v-deep {

      .primary {
        color: $primary-color;
      }

      .luxury {
        color: $luxury-color;
      }
    }

    .achievment__percent {
      font-size: 60px;
    }

    .achievment__percent-info {
      position: relative;
      bottom: 9px;
      left: 7px;
    }

    @media screen and (min-width: $breakpoint-md) and (max-width: $breakpoint-xl) {
      &:nth-child(3n) {
        margin-top: 32px;
      }
    }

    @media screen and (max-width: $breakpoint-md) {
      &:not(:first-child) {
        margin-top: 32px;
      }
    }
  }

  .delimiter {
    background-color: #dbdbdb;
    height: 1px;
    width: 100%;
    opacity: .5;
  }
}
</style>
